import { Function } from '../Function';
import { PostList } from '../Chat/PostList';
import { Post, DummyPlainObject } from '../Chat/Post';

export class Type<T extends Post> implements Function<Post> {
  private _threadList: PostList<T> = new PostList();
  private _lastupdate: Date = new Date();

  public constructor(private _id: string, private _name: string, private _type:string) {
  }

  public get lastupdate(): Date {
    return this._lastupdate;
  }

  public update(): void {
    this._lastupdate = new Date();
  }

  public addThread(threadFirstPost: T): void {
    this._threadList.add(threadFirstPost);
  }

  public hasChildren(): boolean {
    return true;
  }

  get postList(): PostList<T> {
    return this._threadList;
  }

  public get id(): string {
    return this._id;
  }

  public get name(): string {
    return this._name;
  }

  public get type(): string {
    return this._type;
  }

  public toPlainObject(): Object {
    const plainObject: DummyPlainObject = {
      id: this.id,
      name: this.name,
      type: this.type
    }

    if (this.hasChildren()) {
      plainObject['list'] = this.postList.toPlainObject();
    }

    return plainObject;
  }
}

export class Note<ThreadFirstPost> extends Type<Post>  { 
}
export class Announcement<ThreadFirstPost> extends Type<Post> { 
}
export class Consultation<ThreadPost> extends Type<Post> { 
}
export class Task<TaskContent> extends Type<Post> { 
}
export class Talk<ThreadFirstPost> extends Type<Post> { 
}